<div class="container stepper" role="list" aria-label="Progress steps">
  <div class="row row-center">
    @for (step of steps; track $index) {
      <div [ngClass]="getColumnSize(steps.length)" role="listitem" [attr.aria-current]="step.isActive ? 'step' : null">
        <ui-step
          [stepNumber]="$index + 1"
          [stepTitle]="step.title"
          [isActive]="step.isActive"
          [isLastStep]="$index + 1 === steps.length"
          [totalSteps]="steps.length"
        ></ui-step>
      </div>
    }
  </div>
</div>

